// extracted by mini-css-extract-plugin
export default {"container":"TextGraphic_container__recBr","content":"TextGraphic_content__Kky6A","count":"TextGraphic_count__ixC7Q"};